import { personSlice } from 'v3/data/store/person';
import { store } from '..';
import { IPersonalInformation } from './types';

export const setPersonalInformation = (person: IPersonalInformation) => {
  store.dispatch(personSlice.actions.setPersonalInformation(person));
};
export const setHasDimoAccount = (hasDimoAccount: boolean) => {
  store.dispatch(personSlice.actions.setHasDimoAccount(hasDimoAccount));
};
